// extracted by mini-css-extract-plugin
module.exports = {"ReviewsContainer":"ReviewsContainer_ReviewsContainer__1aDNz"};